class DateUtils {
  static date_formate = {
    /** 标准日期格式：yyyy-MM-dd */
    normDatePattern: 'yyyy-MM-dd',
    /** 标准时间格式：hh:mm:ss */
    normTimePattern: 'HH:mm:ss',
    /** 标准日期时间格式，精确到分：yyyy-MM-dd HH:mm */
    normDatetimeMinutePattern: 'yyyy-MM-dd HH:mm',
    /** 标准日期时间格式，精确到秒：yyyy-MM-dd HH:mm:ss */
    normDatetimePattern: 'yyyy-MM-dd HH:mm:ss',
    /** 标准日期时间格式，精确到毫秒：yyyy-MM-dd HH:mm:ss.SSS */
    normDatetimeMsPattern: 'yyyy-MM-dd HH:mm:ss.SSS',
    /** 标准日期格式：yyyy年MM月dd日 */
    chineseDatePattern: 'yyyy年MM月dd日',
    /** 标准日期格式：yyyy年MM月dd日 HH:mm:ss */
    chineseDatetimePattern: 'yyyy年MM月dd日 HH:mm:ss',
    /** 标准日期格式：yyyyMMdd */
    pureDatePattern: 'yyyyMMdd',
    /** 标准日期格式：HHmmss */
    pureTimePattern: 'HHmmss',
    /** 标准日期格式：yyyyMMddHHmmss */
    pureDatetimePattern: 'yyyyMMddHHmmss',
    /** 标准日期格式：yyyyMMddHHmmssSSS */
    pureDatetimeMsPattern: 'yyyyMMddHHmmssSSS'
  }

  constructor() {
    this.timeCounter = null
  }

  /**
   *
   * @param {string} startTime 服务器当前时间
   * @param {string} endTime   倒计时结束时间
   * @param {function} callback 回调函数，返回倒计时剩余时间，秒
   */
  countTimeDown(startTime, endTime, callback) {
    this.stopCountDown()

    const tempStart = DateUtils.format(
      new Date(DateUtils.safeDate(startTime)),
      'yyyy/MM/dd HH:mm:ss'
    )
    const tempEnd = DateUtils.format(
      new Date(DateUtils.safeDate(endTime)),
      'yyyy/MM/dd HH:mm:ss'
    )

    const startTimeMillisecond = new Date(String(tempStart)).getTime()
    const endTimeMillisecond = new Date(String(tempEnd)).getTime()

    // 倒计时的差值（毫秒）
    let ms = endTimeMillisecond - startTimeMillisecond
    callback && callback(ms)

    this.timeCounter = setInterval(() => {
      if (ms > 0) {
        ms -= 1000
        callback && callback(ms)
      } else {
        clearInterval(this.timeCounter)
      }
    }, 1000)
  }

  /**
   * 停止倒计时
   */
  stopCountDown() {
    this.timeCounter && clearInterval(this.timeCounter)
  }

  /**
   * 毫秒转换成时间距离
   * @param {number} millisecond 毫秒
   */
  static formatDuring(millisecond) {
    const days = Math.floor(millisecond / (1000 * 60 * 60 * 24))
    const hours = Math.floor(
      (millisecond % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    )
    const minutes = Math.floor((millisecond % (1000 * 60 * 60)) / (1000 * 60))
    const seconds = Math.floor(millisecond % (1000 * 60)) / 1000
    // return days + " 天 " + hours + " 小时 " + minutes + " 分钟 " + seconds + " 秒 ";
    return {
      days,
      hours,
      minutes,
      seconds
    }
  }

  /**
   * 格式化日期时间
   * 格式 yyyy-MM-dd HH:mm:ss
   *
   * @param date 被格式化的日期
   * @param format 格式化 参考 {@link date_formate}
   * @return 格式化后的日期
   */
  static format(date, format) {
    if (format == undefined || format == null) {
      format = 'yyyy-MM-dd HH:mm:ss'
    }

    const temp = new Date(DateUtils.safeDate(date))
    const o = {
      'M+': temp.getMonth() + 1, // 月份
      'd+': temp.getDate(), // 日
      'H+': temp.getHours(), // 小时
      'h+': temp.getHours(), // 小时
      'm+': temp.getMinutes(), // 分
      's+': temp.getSeconds(), // 秒
      'q+': Math.floor((temp.getMonth() + 3) / 3), // 季度
      S: temp.getMilliseconds() // 毫秒
    }

    if (/(y+)/.test(format)) {
      format = format.replace(
        RegExp.$1,
        (temp.getFullYear() + '').substr(4 - RegExp.$1.length)
      )
    }

    // console.log('date utils format', format)

    for (const k in o) {
      if (new RegExp('(' + k + ')').test(format)) {
        format = format.replace(
          RegExp.$1,
          RegExp.$1.length == 1
            ? o[k]
            : ('00' + o[k]).substr(('' + o[k]).length)
        )
      }
    }

    return format
  }

  /**
   * 兼容Safari的date转换方法
   * @param date 日期
   * @returns {*} 合法日期格式的日期
   */
  static safeDate(date) {
    const arg = date
    if (
      Object.prototype.toString.call(arg) === '[object String]' &&
      arg.indexOf('T') === -1
    ) {
      return arg.replace(/-/g, '/')
      // console.log(arguments[0]);
    } else {
      return arg
    }
  }

  /**
   * 判断一分钟后是否已经是第二天
   * @param {string} date 日期时间
   * @returns {Boolean} 判断结果
   */
  static afterOneMinuteIsNextDay(date) {
    const tempDate = new Date(DateUtils.safeDate(date))
    let afterOneMinuteDate = new Date(DateUtils.safeDate(date))
    afterOneMinuteDate = new Date(
      afterOneMinuteDate.setTime(
        afterOneMinuteDate.setMinutes(afterOneMinuteDate.getMinutes() + 1)
      )
    )
    return tempDate.getDate() !== afterOneMinuteDate.getDate()
  }
}

export default DateUtils
